import { Injectable } from "@angular/core";
import BaseService from "./base.service";
import { rfiAppId } from "@shared/staticValue";
import { DefaultSelection36ApplicationRolePayload } from "../api-generated";

@Injectable({
  providedIn: "root",
})
export default class LocalApplicationRoleService extends BaseService<DefaultSelection36ApplicationRolePayload> {
  public getAppRoles(): DefaultSelection36ApplicationRolePayload[] {
    const items = this.getItems();
    if(!items)
    {
      return items;
    } else{
      return items.filter((role: DefaultSelection36ApplicationRolePayload) => {
        return role.ApplicationId === rfiAppId
      });
    }
    
  }

  public getRoleById(id: string): string {
    return this.getAppRoles().find((role)=>{return role.Guid === id})?.Role ?? '';
  }
}
